import Storage from '../../storage';
import { apiGet } from '../_common';

const API_ADDRESS = process.env.VUE_APP_API_ADDRESS;

export default {
  MIN_SEARCH_QUERY_LENGTH: 6,

  search(query) {
    const q = query && query.query;
    if (typeof q === 'string' && q.length > 0) {
      const digits = q.replace(/\D/g, '');
      if (digits.length < this.MIN_SEARCH_QUERY_LENGTH) {
        return Promise.resolve({
          search: query,
          results: [],
          count: 0,
          totalCount: 0,
        });
      }
    }
    return apiGet('/magenta/fulfillment/cte', query).then(result => result.response);
  },

  findByAccessKey(accessKey) {
    return apiGet(`/magenta/fulfillment/cte/${accessKey}`).then(result => result.response);
  },

  findEvents(accessKey) {
    return apiGet(`/magenta/fulfillment/cte/${accessKey}/events`).then(result => result.response);
  },

  async downloadExport(from, to) {
    const query = new URLSearchParams({ from, to }).toString();
    const response = await fetch(`${API_ADDRESS}/magenta/fulfillment/cte/export?${query}`, {
      headers: {
        Authorization: `Bearer ${Storage.get(Storage.keys.auth.token)}`,
      },
    });

    if (response.status === 404) {
      throw new Error('Nenhum CT-e encontrado no intervalo selecionado.');
    }
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || `Falha ao exportar CT-es (HTTP ${response.status}).`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `ctes_${from}_${to}.zip`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
  },

  eventTypeTranslation: {
    '110110': 'Carta de Correção Eletrônica',
    '110111': 'Cancelamento',
    '110112': 'Cancelamento por Substituição',
    '110140': 'EPEC',
    '110160': 'Registro Multimodal',
    '110170': 'Prestação de Serviço em Desacordo',
    '110180': 'Comprovante de Entrega Eletrônico',
    '110181': 'Cancelamento do Comprovante de Entrega',
    '610110': 'Manifestação de Prestação de Serviço',
    // MDF-e events linked to a CT-e (carrier's transport manifest). Filtered out of
    // the export bundle for accountants, but rendered separately in the Detail view.
    // Codes per SEFAZ tpEvento catalog — note 510620 is outside the `3106xx` range,
    // hence the explicit set rather than a prefix check.
    '310610': 'MDF-e Autorizado',
    '310611': 'MDF-e Cancelado',
    '310620': 'Registro de Passagem',
    '510620': 'Registro de Passagem Automático',
  },

  // tpEvento codes that belong to the MDF-e domain — surfaced separately in the UI
  // and excluded from the export ZIP. Mirrors the backend MDFE_EVENT_TYPES set in
  // CTeService.kt; keep the two in sync if SEFAZ adds new MDF-e event codes.
  MDFE_EVENT_TYPES: new Set(['310610', '310611', '310620', '510620']),

  isMdfeEvent(eventType) {
    return this.MDFE_EVENT_TYPES.has(eventType);
  },

  statusCodeTranslation: {
    '100': 'Autorizado',
    '101': 'Cancelado',
    '110': 'Denegado',
    '135': 'Evento registrado e vinculado a CT-e',
    '136': 'Evento registrado, mas não vinculado a CT-e',
    '155': 'Cancelamento homologado fora do prazo',
    '156': 'Evento aceito fora do prazo',
  },

  describeEventType(eventType) {
    return this.eventTypeTranslation[eventType] || eventType;
  },

  describeStatusCode(statusCode) {
    if (!statusCode) return '';
    return this.statusCodeTranslation[statusCode]
      ? `${statusCode} — ${this.statusCodeTranslation[statusCode]}`
      : statusCode;
  },
};
